export const PAGES = {
    emailValidated: 'emailValidated',
    passwordChanged: 'passwordChanged',
    passwordChanging: 'passwordChanging',
    error: 'errorActionHandler',
    loading: 'loading'
}